import { useTranslation } from 'react-i18next';
import type { ILawLinkMapProps } from './ILawLinkMapProps';
import { groupsOf } from './lawGroups';

/**
 * «Мапа пов'язаних актів» (прототип v4 lawLinks): назва законопроєкту в рамці 2px по центру, під нею — групи за видом зв'язку (у порядку
 * варіантів поля) з пунктирною рамкою: «↑ ЗМІНЮЄ» й акти. Архівні зв'язки не показуються.
 */
export function LawLinkMap({ law, labels, onOpen, draft }: ILawLinkMapProps) {
  const { t } = useTranslation();
  const links = law.of('ldlink').filter((r) => r.status !== 'Archived');
  return (
    <section className="law-sec">
      <div className="law-sec__title">{t('recordPage.law.map')}</div>
      <div className="law-map">
        <div className="law-map__center"><div className="law-map__title">{draft.title}</div></div>
        {groupsOf(links, 'relation', labels.order('ldlink', 'relation')).map((g) => (
          <div key={g.value} className="law-map__group">
            <span className="law-map__label">↑ {labels.option('ldlink', 'relation', g.value)}</span>
            {g.items.map((r) => <button key={r.id} type="button" className="law-map__act" onClick={() => onOpen('ldlink', r)}>{r.title}</button>)}
          </div>
        ))}
      </div>
    </section>
  );
}
